import React, { useEffect, useState, useRef } from 'react';
import { FiBell } from 'react-icons/fi';
import useAxios from '../utils/useAxios';
import './NotificationBell.css';
import {
  FiAlertCircle,
  FiCheckCircle,
  FiInfo,
  FiXCircle
} from 'react-icons/fi';

const NotificationBell = () => {
  const axiosInstance = useAxios();
  const [notifications, setNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const unreadCount = notifications.filter(n => !n.is_read).length;

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const res = await axiosInstance.get('/notification/notifications/');
      setNotifications(res.data);
    } catch (err) {
      console.error("Erreur lors du chargement des notifications :", err);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      await axiosInstance.post(`/notification/notifications/${id}/mark-as-read/`);
      fetchNotifications(); // Recharger les notifications
    } catch (err) {
      console.error("Erreur lors du marquage de la notification :", err);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      await axiosInstance.post('/notification/notifications/mark-all-as-read/');
      fetchNotifications(); // Recharger les notifications
    } catch (err) {
      console.error("Erreur lors du marquage de toutes les notifications :", err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getIconFromTitle = (title) => {
    const lower = title.toLowerCase();
    if (lower.includes('erreur') || lower.includes('échec')) {
      return <FiXCircle color="#dc3545" size={20} />;
    } else if (lower.includes('succès') || lower.includes('réussi')) {
      return <FiCheckCircle color="#28a745" size={20} />;
    } else if (lower.includes('alerte') || lower.includes('attention')) {
      return <FiAlertCircle color="#ffc107" size={20} />;
    } else {
      return <FiInfo color="#1B019B" size={20} />;
    }
  };

  return (
    <div className="notification-container" ref={dropdownRef}>
      <div className="icon-wrapper" onClick={() => setIsOpen(!isOpen)}>
        <FiBell size={24} />
        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
      </div>

      {isOpen && (
        <div className="notification-dropdown">
          <h6>
            Notifications
            {notifications.length > 0 && (
              <button
                onClick={handleMarkAllAsRead}
                style={{
                  float: 'right',
                  fontSize: '12px',
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                  color: '#007bff'
                }}
              >
                Tout marquer comme lu
              </button>
            )}
          </h6>
          <ul>
            {notifications.length === 0 ? (
              <li className="text-center">Aucune notification</li>
            ) : (
              notifications.map((notif) => {
                const icon = getIconFromTitle(notif.title);
                return (
                  <li
                    key={notif.id}
                    className={!notif.is_read ? 'unread' : ''}
                    onClick={() => handleMarkAsRead(notif.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="notification-icon">{icon}</div>
                    <div className="notification-text">
                      <strong>{notif.title}</strong>
                      <p>{notif.body}</p>
                      <small>{new Date(notif.created_at).toLocaleString()}</small>
                    </div>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
